import { createSlice } from '@reduxjs/toolkit';
import { ITuition } from '~/utils/interface/tuition';
import { createTuition, getListTuitions } from './tuitionThunk';
import { RootState } from '~/utils/redux/store';
import { stat } from 'fs';

interface TuitionState {
  tuitions: ITuition[];
  isRefreshListTuition: boolean;
  isLoadingCreateTuition: boolean;
}

const initialState: TuitionState = {
  tuitions: [],
  isRefreshListTuition: false,
  isLoadingCreateTuition: false,
};

const tuitionSlice = createSlice({
  name: 'tuitionSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.tuitions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListTuitions.pending, (state) => {})
      .addCase(getListTuitions.fulfilled, (state, action) => {
        state.tuitions = action.payload.responses;
      })
      .addCase(getListTuitions.rejected, (state) => {})

      // create tuition
      .addCase(createTuition.pending, (state) => {
        state.isLoadingCreateTuition = true;
      })
      .addCase(createTuition.fulfilled, (state, action) => {
        state.isRefreshListTuition = true;
        state.isLoadingCreateTuition = false;
      })
      .addCase(createTuition.rejected, (state) => {
        state.isLoadingCreateTuition = false;
      });
  },
});

// Action
export const tuitionAction = tuitionSlice.actions;

// Selectors
export const selectTuitions = (state: RootState) => state.tuitionState.tuitions;
export const selectIsRefreshListTuition = (state: RootState) => state.tuitionState.isRefreshListTuition;

// Reducer
const tuitionReducer = tuitionSlice.reducer;
export default tuitionReducer;
